import { ServerError } from '../types/types';

export function formatServerError(error: ServerError): string {
    const title = error.title ?? 'Server error';
    const description = error.description?.trim() ?? '';
    return description ? `${title}\n\n${description}` : title;
}
